"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStore = exports.cookieStoreInstance = void 0;
const CookieParser_1 = require("../../../../Services/Storage/Cookie/Polyfill/CookieParser");
const CookieSameSite_1 = require("../../../../Services/Storage/Cookie/CookieSameSite");
const Assert_1 = require("../../../../Utility/Assert");
/**
 * This CookieStore is based on the cookie-store polyfill package: https://github.com/markcellus/cookie-store
 */
class CookieStore extends EventTarget {
    constructor() {
        super();
        throw new TypeError('Illegal Constructor');
    }
    async get(init) {
        if (init == null || (init instanceof Object && !Object.keys(init).length)) {
            throw new TypeError('CookieStoreGetOptions must not be empty');
        }
        return (await this.getAll(init))[0];
    }
    async set(init, possibleValue) {
        const item = {
            domain: null,
            expires: null,
            name: '',
            path: '/',
            sameSite: CookieSameSite_1.default.strict,
            value: ''
        };
        if (typeof init === 'object') {
            Object.assign(item, init);
            this.checkAttributeValidity(item);
        }
        this.setInitValues(item, init, possibleValue);
        const cookieString = this.createCookieString(item);
        document.cookie = cookieString;
    }
    async getAll(init) {
        const cookies = (0, CookieParser_1.parse)(document.cookie);
        if (init == null || Object.keys(init).length === 0) {
            return cookies;
        }
        let name;
        let url;
        if (typeof init === 'string') {
            name = init;
        }
        else {
            name = init.name;
            url = init.url;
        }
        if (url) {
            return cookies.slice(0, 1);
        }
        return cookies.filter((cookie) => cookie.name === name);
    }
    async delete(init) {
        const item = {
            name: '',
            value: '',
            path: '/',
            sameSite: CookieSameSite_1.default.strict,
            expires: null,
            domain: null
        };
        if (typeof init === 'string') {
            item.name = init;
        }
        else {
            Object.assign(item, init);
        }
        item.expires = 0;
        await this.set(item);
    }
    createCookieString(item) {
        let cookieString = `${item.name}=${encodeURIComponent(Assert_1.default.notUndefined(item.value))}`;
        // Due to closed mocha environment this line is hard to test because of
        // stubborn window.location.hostname (not mockable in newer jsdom versions)
        // and because the error: Cookie domain must domain-match current host in checkAttributeValidity() being hit
        // istanbul ignore next
        if (item.domain) {
            // istanbul ignore next
            cookieString += '; Domain=' + item.domain;
        }
        if (item.path) {
            cookieString += '; Path=' + item.path;
        }
        if (typeof item.expires === 'number') {
            cookieString += '; Expires=' + new Date(item.expires).toUTCString();
        }
        if (item.name && (item.name.startsWith('__Secure') || item.name.startsWith('__Host'))) {
            item.sameSite = CookieSameSite_1.default.lax;
            cookieString += '; Secure';
        }
        switch (item.sameSite) {
            case CookieSameSite_1.default.lax:
                cookieString += '; SameSite=Lax';
                break;
            case CookieSameSite_1.default.strict:
                cookieString += '; SameSite=Strict';
                break;
            case CookieSameSite_1.default.none:
                cookieString += '; SameSite=None';
                break;
        }
        return cookieString;
    }
    setInitValues(item, init, possibleValue) {
        var _a;
        if (typeof init === 'string') {
            item.name = init;
            item.value = Assert_1.default.notUndefined(possibleValue);
        }
        else {
            if ((_a = item.path) === null || _a === void 0 ? void 0 : _a.endsWith('/')) {
                item.path = item.path.slice(0, -1);
            }
            if (item.path === '') {
                item.path = '/';
            }
        }
    }
    checkAttributeValidity(item) {
        var _a, _b;
        if (item.path && !item.path.startsWith('/')) {
            throw new TypeError('Cookie path must start with "/"');
        }
        if ((_a = item.domain) === null || _a === void 0 ? void 0 : _a.startsWith('.')) {
            throw new TypeError('Cookie domain cannot start with "."');
        }
        if (item.name) {
            if (item.name.startsWith('__Host') && item.domain) {
                throw new TypeError('Cookie domain must not be specified for host cookies');
            }
            if (item.name.startsWith('__Host') && item.path !== '/') {
                throw new TypeError('Cookie path must not be specified for host cookies');
            }
        }
        if (item.domain && item.domain !== window.location.hostname) {
            throw new TypeError('Cookie domain must domain-match current host');
        }
        if ((_b = item.value) === null || _b === void 0 ? void 0 : _b.includes('=')) {
            throw new TypeError('Cookie value cannot contain \'=\' if the name is empty');
        }
    }
}
exports.CookieStore = CookieStore;
/**
 * If we want ServiceWorkers to subscribe to cookie change events (which up until this date is never implemented in our codebase)
 * We will need to create a polyfill for the CookieStoreManager as well
 */
const cookieStoreInstance = Object.create(CookieStore.prototype);
exports.cookieStoreInstance = cookieStoreInstance;
//# sourceMappingURL=CookieStore.js.map